import axios from 'axios';
import { notification } from 'antd';

class Network {
  constructor() {
    this.AUTH_TOKEN = window.localStorage.getItem('AUTH_TOKEN');
    let HOST = window.location.origin;

    if (process.env.NODE_ENV !== 'production') {
      HOST = process.env.REACT_APP_API_HOST || 'https://116.62.88.99:8443';
    }

    this.baseConfig = {
      method: 'get',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.AUTH_TOKEN,
      },
      baseURL: HOST,
    };
  }

  async axios(config) {
    const response = await axios({ ...this.baseConfig, ...config });
    console.log('response', response);
    // 200, 201, 202, 204 都是成功状态
    // 204 No Content 没有响应体，所以不检查 response.data
    if ([200, 201, 202, 204].some(item => item === response.status)) {
      return response;
    }
    notification.error({ message: '网络请求错误' });
    return Promise.reject(response);
  }

  normalCallback(data) {
    // 204 No Content 响应没有body，直接返回空对象
    if (data.status === 204) {
      return {};
    }
    return data.data;
  }

  get(url, params) {
    return this.axios({ url, params }).then(this.normalCallback);
  }

  post(url, data) {
    return this.axios({ method: 'post', url, data }).then(this.normalCallback);
  }

  put(url, data) {
    return this.axios({ method: 'put', url, data }).then(this.normalCallback);
  }

  delete(url, data, config = {}) {
    return this.axios({ method: 'delete', url, data, ...config }).then(this.normalCallback);
  }

  download(url, params = {}, suffix = '', onDownloadProgress) {
    return this.axios({
      headers: { Authorization: this.AUTH_TOKEN },
      url,
      params,
      responseType: 'arraybuffer',
      onDownloadProgress,
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', Date.now() + '.' + suffix);
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
      }, 1000);
    });
  }

  queryImage(imageKey) {
    return this.axios({ url: '/api/attendance/image', params: { objectKey: imageKey },
    }).then(this.normalCallback);
  }

  saveLoginResponse(response) {
    if (response.status === 200) {
      this.AUTH_TOKEN = 'Bearer ' + response.data.token;
      localStorage.setItem('AUTH_TOKEN', this.AUTH_TOKEN);
    }
    return response.data;
  }

  login(data = {}) {
    return this.axios({
      method: 'post',
      withCredentials: false,
      headers: { 'Content-Type': 'application/json' },
      url: '/api/auth/loginAdmin',
      data,
    }).then(response => this.saveLoginResponse(response));
  }

  getDingTalkConfig() {
    return this.axios({
      withCredentials: false,
      headers: { 'Content-Type': 'application/json' },
      url: '/api/auth/dingtalk/config',
    }).then(this.normalCallback);
  }

  dingTalkInternalLogin(authCode) {
    return this.axios({
      method: 'post',
      withCredentials: false,
      headers: { 'Content-Type': 'application/json' },
      url: '/api/auth/dingtalk/internal',
      data: { authCode },
    }).then(response => this.saveLoginResponse(response));
  }

  logout() {
    return this.axios({ url: '/api/auth/logout' }).then((response) => {
      if (response.status === 200) {
        this.AUTH_TOKEN = '';
        localStorage.setItem('AUTH_TOKEN', this.AUTH_TOKEN);
      }
      return response.data;
    });
  }
}

export default new Network();
